import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';

import { CalculationService, HelperService, HTTPService, DataService, FormatService } from 'app/services';
import { TireAddToCartDialogComponent } from '../tire-add-to-cart-dialog/tire-add-to-cart-dialog.component';
import { TireDetailsComponent } from '../tire-details/tire-details.component';

import { Subscription } from 'rxjs';
import { debounce, orderBy as lodashOrderBy } from 'lodash';
import * as moment from 'moment';

@Component({
  selector: 'app-tirehub-lookup',
  templateUrl: './tirehub-lookup.component.html',
  styleUrls: ['./tirehub-lookup.component.scss'],
  providers: [DialogService],
})
export class TirehubLookupComponent implements OnInit, OnDestroy {
  @Input() tireHubSettings: any = {};
  @Input() isOpenFromRO: boolean = false;
  @Input() isOpenFromQuickTireLookup: boolean = false;
  @Input() tireHubSesssionId: string = '';
  @Input() isEmptySizes: boolean = false;
  @Input() isShippingCalculating: boolean = false;
  @Input() isTabActive: boolean = false;
  @Input() isCartVisible: boolean = false;
  @Input() isTireSizesLoading: boolean = false;
  @Input() brands: any[] = [];
  @Input() seasons: any[] = [];
  @Input() loadIndexes: any[] = [];
  @Input() speedRatings: any[] = [];
  @Input('warehouses')
  set setWarehouses(warehouses: string) {
    this.multipleGenericFiltersObject.warehouse.data = warehouses;
  }
  @Input('brands')
  set setBrands(brands: string) {
    this.multipleGenericFiltersObject.brand.data = brands;
  }
  @Input('loadIndexes')
  set setLoadIndexes(loadIndexes: string) {
    this.multipleGenericFiltersObject.loadIndex.data = loadIndexes;
  }
  @Input('speedRatings')
  set setSpeedRating(speedRatings: string) {
    this.multipleGenericFiltersObject.speedRating.data = speedRatings;
  }
  @Input('selectedTireSize')
  set fetchTires(selectedTireSize: any) {
    if (this.isQTQAddOnEnable) {
      if (selectedTireSize && Object.keys(selectedTireSize)?.length > 0) {
        this.tireSize = selectedTireSize.tireSize;
        this.tireWidth = selectedTireSize.tireWidth;
        this.tireProfile = selectedTireSize.tireProfile;
        this.pageNumber = 1;

        if (this.isTabActive) {
          this.getTireHubInventory();
        }
      }
    } else {
      if (selectedTireSize) {
        this.tireSize = selectedTireSize;
        this.pageNumber = 1;

        if (this.isTabActive) {
          this.getTireHubInventory();
        }
      }
    }
  }
  @Input('selectedTab')
  set tabSelectionAction(selectedTab: number) {
    if (selectedTab === 1) {
      if (this.tires && !this.tires.length) {
        this.getTireHubInventory();
      }
    }
  }
  @Input('attrType')
  set attrType(attrType: string) {
    if (attrType && this.isTabActive) {
      if (!this.isQTQAddOnEnable) {
        this.getTireAttr(attrType);
      }
    }
  }
  @Input() selectedAttr: any = {
    tireWidth: { _id: null },
    tireProfile: { _id: null },
    tireSize: { _id: null },
  };
  @Input('emptyCart')
  set emptyCart(empty: boolean) {
    if (empty) {
      this.removeCartItems();
    }
  }
  @Input() selectedQty: number = 4;
  @Input() globalCartItemList: any = [];
  @Input() globalCartCount: number = 0;
  @Input() defaultServiceTotal: number = 0;
  @Input() hideCost: boolean = false;
  @Input('setSelectedTax')
  set setSelectedTax(tax: any) {
    this.selectedTax = tax;
    if (this.isQTQAddOnEnable) {
      if (this.tires?.length) {
        this.handleTaxSelect();
      }
    }
  }
  @Input('setSelectedPricingMatrix')
  set setSelectedPricingMatrix(pricing: any) {
    this.selectedPricingMatrix = pricing;
    if (this.tires?.length) {
      this.handlePricingMatrixSelect();
    }
  }
  @Input() taxAmtOnAdonService: number = 0;
  @Input() isRunTireStorageFlow: boolean = false;

  @Output() updateSelectedItemCount = new EventEmitter();
  @Output() appSetTireHubTireSizeAttr = new EventEmitter();
  @Output() showLoader = new EventEmitter();
  @Output() appOnAddCustomerAndVehicle = new EventEmitter();
  @Output() appOnSetGlobalCart = new EventEmitter();
  @Output() appOnCalculatingShipping = new EventEmitter();

  isItemAlreadyExists = false;
  isLoading: boolean = false;
  orderId: string = '';
  cartId: string = '';
  vehicle: any = {};
  services: any[] = [];
  tires: any[] = [];
  tireWidths: any[] = [];
  tireSizes: any[] = [];
  tireProfiles: any[] = [];
  searchQuery: string = '';
  selectedTire: any = {};
  isTireSelected: boolean = false;
  filterOptions = {
    multipleGenericFilters: true,
  };
  preAppliedFilter = null;
  isTireHubModal: boolean = false;
  filterOptionStylecss: any = {
    width: '120px',
    'font-weight': '600',
    padding: '0 3px',
  };
  multipleGenericFiltersKeys: any = ['leadTime', 'warehouse', 'loadIndex', 'speedRating', 'availability', 'brand', 'orderBy'];
  multipleGenericFiltersObject: any = {
    brand: {
      data: [],
      filterOptions: {
        iconClass: 'fa-check',
        nameField: 'name',
        valueField: '_id',
        selectAllText: 'Brand',
        multipleSelectText: 'Multiple brands',
        styleCss: this.filterOptionStylecss,
        filterOverlayStyle: {
          width: '173px',
        },
        isSingleSelect: true,
      },
      filterApplied: false,
      selected: [],
    },
    speedRating: {
      data: [],
      filterOptions: {
        iconClass: 'fa-bars',
        nameField: 'name',
        valueField: '_id',
        selectAllText: 'Speed rating',
        multipleSelectText: 'Multiple Speed rating',
        styleCss: this.filterOptionStylecss,
        filterOverlayStyle: {
          width: '173px',
        },
        isSingleSelect: true,
      },
      filterApplied: false,
      selected: [],
    },
    loadIndex: {
      data: [],
      filterOptions: {
        iconClass: 'fa-bars',
        nameField: 'name',
        valueField: '_id',
        selectAllText: 'Load index',
        multipleSelectText: 'Multiple Load index',
        styleCss: this.filterOptionStylecss,
        filterOverlayStyle: {
          width: '173px',
        },
        isSingleSelect: true,
      },
      filterApplied: false,
      selected: [],
    },
    warehouse: {
      data: [],
      filterOptions: {
        iconClass: 'fa-warehouse',
        nameField: 'name',
        valueField: '_id',
        selectAllText: 'Warehouse',
        multipleSelectText: 'Multiple Warehouse',
        styleCss: this.filterOptionStylecss,
        filterOverlayStyle: {
          width: '173px',
        },
        isSingleSelect: true,
      },
      filterApplied: false,
      selected: [],
    },
    leadTime: {
      data: [
        {
          name: 'Today',
          _id: 'Today',
        },
        {
          name: 'Tomorrow',
          _id: 'Tomorrow',
        },
        {
          name: 'Up to 2 days',
          _id: 'UpToTwoDays',
        },
        {
          name: 'Up to 3 days',
          _id: 'UpToThreeDays',
        },
        {
          name: 'More than 3 days',
          _id: 'MoreThan3Days',
        },
      ],
      filterOptions: {
        iconClass: 'fa-calendar-alt',
        nameField: 'name',
        valueField: '_id',
        selectAllText: 'Lead Time',
        multipleSelectText: 'Lead Time',
        styleCss: this.filterOptionStylecss,
        filterOverlayStyle: {
          width: '173px',
        },
        isSingleSelect: true,
      },
      filterApplied: false,
      selected: [],
    },
    orderBy: {
      data: [
        { _id: 'low_stock', name: 'Stock: low to high' },
        { _id: 'high_stock', name: 'Stock: high to low' },
        { _id: 'brand_asc', name: 'Brand: A to Z' },
        { _id: 'brand_desc', name: 'Brand: Z to A' },
        { _id: 'price_asc', name: 'Price: low to high' },
        { _id: 'price_desc', name: 'Price: high to low' },
      ],
      filterOptions: {
        iconClass: 'fa-sort-alt',
        nameField: 'name',
        valueField: '_id',
        selectAllText: 'Sort by',
        multipleSelectText: 'Multiple selected',
        styleCss: this.filterOptionStylecss,
        filterOverlayStyle: {
          width: '173px',
        },
        isSingleSelect: true,
      },
      filterApplied: false,
      selected: [],
    },
    availability: {
      data: [
        { _id: 'all', name: 'All' },
        { _id: 'local', name: 'Local only' },
      ],
      filterOptions: {
        iconClass: 'fa-check',
        nameField: 'name',
        valueField: '_id',
        selectAllText: 'Availability',
        multipleSelectText: 'Multiple selected',
        styleCss: this.filterOptionStylecss,
        filterOverlayStyle: {
          width: '173px',
        },
        isSingleSelect: true,
      },
      filterApplied: true,
      selected: [{ _id: 'all', name: 'All' }],
    },
  };
  filter: any = {};
  cartDetails = {};
  cartitemList = [];
  cartSummary = {
    total: 0,
    shippingCost: 0,
    grand: 0,
    count: 0,
    totalPrice: 0,
    grandPrice: 0,
    totalTaxAmount: 0,
    totalFetValue: 0,
  };
  currentTime: Date;
  pageSize: number = 13;
  pageNumber: number = 1;
  isTireFetching: boolean = false;
  isSubmitting: boolean = false;
  tireSize: string = '';
  tireWidth: string = '';
  tireProfile: string = '';
  inventoryType: string = 'inventoryByLeadTime'; // inventory, inventoryByLeadTime
  warehouseShippings = {};
  shippingLoader = {};
  // These are specific to TireHub
  deliveryStatus = {
    1: 'Preparation',
    2: 'In Transit',
    3: 'Arrived',
    4: 'Delivered',
  };
  deliverType = {
    0: 'Unspecified Delivery',
    1: 'TirehubTruck',
    2: 'Fedex',
    3: 'UPS',
    4: 'Regional Carrier',
    5: 'Pickup',
    6: 'Drop Ship',
    7: 'Express Delivery',
  };
  selectedTireId = {};
  isQTQAddOnEnable: boolean = this.dataService.isQTQAddOnEnable;
  isPassThroughTaxEnable: boolean = this.dataService.isPassThroughTaxEnable;
  dataServiceSubscription: Subscription;
  selectedTax: any = {};
  selectedPricingMatrix: any =  { name: 'Regular Customers Pricing', value: 'regular', showSelected: 'Regular Customers Pricing' };

  constructor(
    private dialogService: DialogService,
    private httpService: HTTPService,
    private helperService: HelperService,
    private dynamicDialogRef: DynamicDialogRef,
    private dynamicDialogConfig: DynamicDialogConfig,
    private calculationService: CalculationService,
    private dataService: DataService,
    private formatService: FormatService
  ) {}

  ngOnInit() {
    const { vehicle, services, orderId } = this.dynamicDialogConfig.data;

    this.orderId = orderId;
    this.services = services;
    this.vehicle = vehicle;

    if (!this.isOpenFromQuickTireLookup) {
      this.isTireSizesLoading = false;
      this.getOrderQoute();
      if (!this.isQTQAddOnEnable) {
        this.getTireAttr('tireWidths');
      }
    } else {
      if (!this.isQTQAddOnEnable) {
        this.getTireAttr();
      }
    }

    if (this.isQTQAddOnEnable) {
      this.setDataListners();
    }

    if (this.helperService.getCompany().isMultiLocationEnabled) {
      this.multipleGenericFiltersObject.availability.data.push({ _id: 'local_or_other', name: 'Local or other only' });
    }
  }

  setDataListners() {
    this.dataServiceSubscription = this.dataService.getData().subscribe((obj) => {
      if (obj.data.key === 'handleTireSelect' && obj.data?.data?.source === 'tirehub') {
        this.handleTireSelect(obj.data?.data?.tireId, obj.data?.data?.tire, obj.data.key);
      }
      if (obj.data.key === 'handleCountChange' && obj.data?.data?.source === 'tirehub') {
        this.handleCountChange(obj.data?.data?.tireId, obj.data?.data?.count, false, obj.data.key);
      }
    });
  }

  ngOnDestroy() {
    if (this.dataServiceSubscription) {
      this.dataServiceSubscription.unsubscribe();
    }
  }

  getOrderQoute() {
    this.httpService.getPartsOrderingQoute(this.orderId, { source: 'tireHub', sessionId: this.tireHubSesssionId, fetchUnOrdered: true }).then(
      (data: any) => {
        // console.log(data);
        if (data?.quote?.orders?.length) {
          data.quote.orders.forEach((order: any) => {
            if (order?.items?.length) {
              this.isItemAlreadyExists = true;
              order.items.forEach((item: any) => {
                this.selectedTire[item.orderItemId] = item;
                this.cartDetails[item.orderItemId] = item;
              });
            }

            if (order?.summary?.shippingCost) {
              this.warehouseShippings[order?.warehouse?.warehouseId] = order?.summary?.shippingCost;
            }
          });

          this.setCartDetails();
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  getTireHubInventory = debounce(() => {
    if (!this.isQTQAddOnEnable) {
      if (!this.isTabActive || (!this.isEmptySizes && !this.tireSize) || this.isTireFetching) {
        return;
      }
    } else {
      if ((!this.isTabActive || (!this.isEmptySizes && !this.tireSize && !this.tireWidth && !this.tireProfile) || this.isTireFetching) && this.isQTQAddOnEnable) {
        return;
      }
    }

    const { brand, leadTime, loadIndex, speedRating, warehouse, orderBy, availability } = this.filter;
    const options: any = {
      tireSize: this.tireSize,
      brand: brand,
      leadTime: leadTime,
      loadIndex: loadIndex,
      orderBy: orderBy,
      speedRating: speedRating,
      availability: availability,
      warehouses: warehouse,
      pageSize: this.pageSize,
      pageNumber: this.pageNumber,
      inventoryType: this.inventoryType,
    };
    const seasonMap = {
      Unknown: 'all',
      Winter: 'winter',
      Summer: 'summer',
      'All-Season': 'all',
    };

    if (this.pageNumber === 1) {
      this.tires = [];
    }

    if (this.isQTQAddOnEnable) {
      options.fetchQTQData = true;
      options.tireWidth = this.tireWidth;
      options.tireProfile = this.tireProfile;
    } else {
      options.fetchQTQData = false;
    }
    this.isLoading = this.pageNumber === 1;
    this.isTireFetching = true;
    if (this.selectedPricingMatrix && Object.keys(this.selectedPricingMatrix).length > 0 && this.dataService.isAttributeBasedPricingEnable) {
      this.selectedPricingMatrix = this.tireHubSettings?.tire?.pricingRule?.filter((rule) => rule.name === this.selectedPricingMatrix?.name);
    
      if(this.selectedPricingMatrix?.length) {
        this.selectedPricingMatrix = this.selectedPricingMatrix[0];
      }
    }

    this.httpService
      .getTireHubInventory(options)
      .then(
        (data: any) => {
          const { tires, currentTime } = data;

          this.currentTime = currentTime;

          if (tires?.length >= 0) {
            this.tires = [
              ...this.tires,
              ...tires.map((inventory: any) => {
                const { localAvailable, otherAvailable, localFetValue } = this.formatService.getLocalAndOtherInvCount(inventory?.localTires);
                const { warehouses } = inventory;
                const parsedTireSize = this.helperService.tireSizeParser(inventory.tireSize);
                const tire: any = {
                  _id: '',
                  orderItemId: '',
                  numericItemId: inventory?.numericItemId,
                  partNumber: inventory?.itemId,
                  displayTitle: `${inventory?.brand} ${inventory?.model}`,
                  title: `${inventory.brand} ${inventory.model} ${parsedTireSize?.tireSizeSearch || ''}`,
                  brand: inventory.brand,
                  model: inventory.model,
                  size: inventory.tireSize,
                  seasonality: seasonMap[inventory.season] || 'all',
                  cost: Number(inventory.basePrice || 0),
                  price: Number(inventory.listPrice ?? inventory.basePrice ?? 0),
                  defaultPrice: Number(inventory.listPrice ?? inventory.basePrice ?? 0),
                  count: Number(inventory.baseQuantity || 1) ?? 1,
                  totalCount: 0,
                  countAvailable: Number(inventory.quantityAvailable || 0),
                  inventory,
                  manufacturer: inventory.manufacturer,
                  image: inventory.ecommerceImageUrl,
                  estimatedDeliveryDay: '',
                  warehouse: {},
                  locations: [],
                  loadIndex: inventory?.loadIndex,
                  speedRating: inventory?.speedRating,
                  warranty: inventory?.warrantyMiles,
                  sideWallStyle: inventory?.sidewall,
                  threadDepth: inventory?.threadDepth,
                  utqg: inventory?.utqg,
                  runFlat: inventory?.runFlat ? 'Yes' : 'No',
                  localAvailable: localAvailable || 0,
                  otherAvailable: otherAvailable || 0,
                  fetValue: localFetValue || 0,
                  localFetValue,
                  fetValueSource: inventory?.fet ? 'tireconnect' : 'local',
                  tireconnectFetSource: inventory?.fet_source === 'tireconnect' ? inventory?.fet_source : '',
                  tireconnectFetValue: inventory?.fet || 0,
                  category: inventory?.category,
                  tireType: inventory?.tire_type,
                };

                if (this.inventoryType === 'inventoryByLeadTime') {
                } else {
                  tire.totalCount = tire.count;
                }

                if (warehouses?.length) {
                  const [warehouse] = warehouses;
                  const deliveryDays = moment(new Date(warehouse.estimatedDeliveryDate)).diff(moment(currentTime), 'days');

                  tire._id = [warehouse?.warehouseId, inventory.numericItemId].filter((str) => str).join('-');
                  tire.orderItemId = tire._id;
                  tire.warehouse = warehouse;
                  console.log(tire.orderItemId);

                  if (!this.isItemAlreadyExists) {
                    tire.orderItemIdUnique = `${Date.now()}-${tire.orderItemId}`;
                  }

                  if (deliveryDays) {
                    tire.estimatedDeliveryDay = `${deliveryDays} working days`;
                  } else {
                    tire.estimatedDeliveryDay = `Same day`;
                  }
                }

                if (inventory?.itemAvailability?.length) {
                  tire.locations = [];
                  let totalAvailableTires: number = 0;

                  inventory.itemAvailability.forEach(({ details }, availabilityIndex: number) => {
                    if (details?.length) {
                      details.forEach((detail: any, detailIndex: number) => {
                        const { leadTime, totalAvailable, warehouseId, warehouseName, estimatedDeliveryDate } = detail;
                        let estimatedDeliveryDay: string;

                        if (!['Today', 'Tomorrow'].includes(leadTime)) {
                          const deliveryDays = moment(new Date(estimatedDeliveryDate)).diff(moment(this.currentTime), 'days');
                          estimatedDeliveryDay = `${deliveryDays} days`;
                        } else {
                          estimatedDeliveryDay = leadTime;
                        }
                        totalAvailableTires += totalAvailable;

                        tire.locations.push({
                          warehouseId,
                          name: warehouseName,
                          leadTime: leadTime,
                          estimatedDeliveryDay,
                          totalAvailable,
                          itemId: inventory?.itemId,
                          count: 0,
                        });
                      });
                    }
                  });

                  if (this.isQTQAddOnEnable && !tire.countAvailable) {
                    tire.countAvailable = totalAvailableTires;
                    if (tire.locations && tire.locations.length) {
                      tire.estimatedDeliveryDay = tire.locations[0].estimatedDeliveryDay;
                    }
                  }
                }

                if (inventory?.localTires?.length && this.isQTQAddOnEnable) {
                  const { localLocations, otherLocations } = this.formatService.getLocalAndOtherLocations(inventory?.localTires, inventory?.itemId);
                  tire.localLocations = localLocations;
                  tire.otherLocations = otherLocations;
                  tire.localCost = localLocations?.length ? localLocations[0].cost : 0;
                  tire.otherCost = otherLocations?.length ? otherLocations[0].cost : 0;
                }

                let isTirePriceUpdated = false;
                if (this.dataService.isAttributeBasedPricingEnable && this.selectedPricingMatrix && Object.keys(this.selectedPricingMatrix).length > 0 && ['regular', 'fleet', 'custom'].includes(this.selectedPricingMatrix.type)) {
                  isTirePriceUpdated = true;
                  tire.price = this.calculationService.calculateMarkUpUsingPricing(tire.cost, this.selectedPricingMatrix?.defaultMatrix);
                } else if (this.tireHubSettings?.tire?.partsTechCostCalMethod === 'pricing-matrix') {
                  isTirePriceUpdated = true;
                  tire.price = this.calculationService.calculateMarkUpUsingPricing(tire.cost, this.tireHubSettings?.tire?.pricing);
                }
                if(!isTirePriceUpdated) {
                  tire.price = tire.defaultPrice;
                }

                return tire;
              }),
            ];

            if (this.filter.availability) {
              if (this.filter.availability[0] === 'local') {
                this.tires = this.tires.filter(({ localAvailable }) => localAvailable);
              } else if (this.filter.availability[0] === 'local_or_other') {
                this.tires = this.tires.filter(({ localAvailable, otherAvailable }) => localAvailable || otherAvailable);
              }
            }

            if (this.filter.orderBy) {
              if (this.filter.orderBy[0] === 'low_stock') {
                this.tires = lodashOrderBy(this.tires, ['localAvailable', 'otherAvailable'], ['asc', 'asc']);
              } else if (this.filter.orderBy[0] === 'high_stock') {
                this.tires = lodashOrderBy(this.tires, ['localAvailable', 'otherAvailable'], ['desc', 'desc']);
              }
            }
          }

          if (this.inventoryType === 'inventory') {
            this.pageNumber++;
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isLoading = false;
        this.isTireFetching = false;
        this.isTireSizesLoading = false;
      });
  }, 1000);

  handlePricingMatrixSelect() {
    this.selectedPricingMatrix = this.tireHubSettings?.tire?.pricingRule?.filter((rule) => rule.name === this.selectedPricingMatrix?.name);
    if (this.selectedPricingMatrix?.length) {
      this.selectedPricingMatrix = this.selectedPricingMatrix[0];
    }

    this.tires.forEach((tire: any) => {
      let isTirePriceUpdated = false;
      if (this.selectedPricingMatrix && ['regular', 'fleet', 'custom'].includes(this.selectedPricingMatrix.type)) {
        isTirePriceUpdated = true;
        tire.price = this.calculationService.calculateMarkUpUsingPricing(tire.cost, this.selectedPricingMatrix?.defaultMatrix);
      } else if (this.tireHubSettings?.tire?.partsTechCostCalMethod === 'pricing-matrix') {
        isTirePriceUpdated = true;
        tire.price = this.calculationService.calculateMarkUpUsingPricing(tire.cost, this.tireHubSettings?.tire?.pricing);
      }

      if(!isTirePriceUpdated) {
        tire.price = tire.defaultPrice;
      }
    });
  }

  getTireAttr(type: string = 'tireWidths') {
    const options: any = {};

    if (this.selectedAttr.tireWidth && this.selectedAttr.tireWidth._id) {
      options.width = this.selectedAttr.tireWidth._id;
    }

    if (this.selectedAttr.tireProfile && this.selectedAttr.tireProfile._id) {
      options.profile = this.selectedAttr.tireProfile._id;
    }

    this.showLoader.emit(true);

    this.httpService
      .getTireHubTireAttr(options)
      .then(
        (attr) => {
          if (type === 'tireWidths' && attr?.widths?.length) {
            this.tireWidths = attr.widths.map((width: any) => {
              return { _id: width.toString() };
            });
          } else if (type === 'tireSizes' && attr?.sizes?.length) {
            this.tireSizes = attr.sizes.map((size: any) => {
              return { _id: size.toString() };
            });
          } else if (type === 'tireProfiles' && attr?.profiles?.length) {
            this.tireProfiles = attr.profiles.map((profile: any) => {
              return { _id: profile.toString() };
            });
          }

          if (this.isTabActive) {
            this.appSetTireHubTireSizeAttr.emit({ widths: this.tireWidths, profiles: this.tireProfiles, sizes: this.tireSizes });
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isLoading = false;
        this.isTireSizesLoading = false;
        this.showLoader.emit(false);
      });
  }

  filterChange(filter: any) {
    this.filter = {
      brand: [],
      categories: [],
      loadIndex: [],
      season: [],
      speedRating: [],
      leadTime: [],
      warehouse: [],
      orderBy: [],
      availability: [],
    };

    const { brand, loadIndex, speedRating, leadTime, warehouse, orderBy, availability } = filter;

    if (brand?.selected?.length) {
      this.filter.brand = brand?.selected.map(({ _id }) => _id)[0];
    }

    if (leadTime?.selected?.length) {
      this.filter.leadTime = leadTime?.selected.map(({ _id }) => _id)[0];
    }

    if (loadIndex?.selected?.length) {
      this.filter.loadIndex = loadIndex?.selected.map(({ _id }) => _id)[0];
    }

    if (speedRating?.selected?.length) {
      this.filter.speedRating = speedRating?.selected.map(({ _id }) => _id)[0];
    }

    if (warehouse?.selected?.length) {
      this.filter.warehouse = warehouse?.selected.map(({ _id }) => _id);
    }

    if (availability?.selected?.length) {
      this.filter.availability = availability?.selected.map(({ _id }) => _id);
    }

    if (orderBy?.selected?.length) {
      this.filter.orderBy = orderBy?.selected.map(({ _id }) => _id);
    }

    this.pageNumber = 1;
    this.getTireHubInventory();
  }

  setCartDetails = debounce(async (isAddedToCart?: boolean, callingFrom?: string) => {
    const groupedTires = {};

    this.selectedTireId = {};

    Object.values(this.cartDetails).forEach((tire: any) => {
      if (tire?.warehouse?.warehouseId && !groupedTires[tire.warehouse.warehouseId]) {
        groupedTires[tire.warehouse.warehouseId] = {
          warehouseId: tire.warehouse.warehouseId,
          warehouseName: tire.warehouse.name,
          tires: [],
          total: {
            total: 0,
            cost: 0,
            price: 0,
            totalPrice: 0,
            totalTaxAmount: 0,
            totalFetValue: 0,
            shippingCost: this.warehouseShippings[tire.warehouse.warehouseId] || 0,
          },
        };
      }

      groupedTires[tire.warehouse.warehouseId].tires.push(tire);
      groupedTires[tire.warehouse.warehouseId].total.cost += tire.cost * tire.count;

      const { cost, shippingCost } = groupedTires[tire.warehouse.warehouseId].total;

      groupedTires[tire.warehouse.warehouseId].total.total = cost + shippingCost;

      if (this.isOpenFromQuickTireLookup || this.isOpenFromRO) {
        groupedTires[tire.warehouse.warehouseId].total.price += tire.price * tire.count;

        const { price, shippingCost } = groupedTires[tire.warehouse.warehouseId].total;

        groupedTires[tire.warehouse.warehouseId].total.totalPrice = price + shippingCost;

        if (this.isQTQAddOnEnable) {
          groupedTires[tire.warehouse.warehouseId].total.totalTaxAmount += (tire?.tireSalesTaxAmt || 0) * tire.count;

          if (this.isPassThroughTaxEnable) {
            groupedTires[tire.warehouse.warehouseId].total.totalFetValue += (tire?.fetValue || 0) * tire.count;
          }
        }
      }
    });

    if (isAddedToCart) {
      this.cartitemList?.forEach((warehouse: any) => {
        if (groupedTires[warehouse?.warehouseId]) {
          warehouse.warehouseId = groupedTires[warehouse?.warehouseId]?.warehouseId;
          warehouse.warehouseName = groupedTires[warehouse?.warehouseId]?.warehouseName;
          warehouse.tires = groupedTires[warehouse?.warehouseId]?.tires;
          warehouse.total = groupedTires[warehouse?.warehouseId]?.total;
        }
      });
    } else {
      this.cartitemList = Object.values(groupedTires);
    }
    //this.cartitemList = Object.values(groupedTires);

    Object.values(this.selectedTire).forEach(({ numericItemId, price, count, warehouse, tireSalesTaxAmt = 0, fetValue = 0 }: any) => {
      if (!this.selectedTireId[numericItemId]) {
        this.selectedTireId[numericItemId] = { count: 0, amount: 0, locations: {} };
      }

      this.selectedTireId[numericItemId].locations[warehouse?.warehouseId] = { warehouseId: warehouse?.warehouseId, count };
      this.selectedTireId[numericItemId].count += count;

      if (this.isQTQAddOnEnable) {
        this.selectedTireId[numericItemId].amount += (price + tireSalesTaxAmt) * count;
        if (this.isPassThroughTaxEnable) {
          this.selectedTireId[numericItemId].amount += fetValue * count;
        }
      } else {
        this.selectedTireId[numericItemId].amount += price * count;
      }
    });

    this.setCartSummary(callingFrom);
    this.setItemCount();
  }, 600);

  setGlobalCartAdSummary(callingFrom?: string) {
    this.appOnSetGlobalCart.emit({
      cartitemList: this.cartitemList,
      cartSummary: this.cartSummary,
      selectedTireId: this.selectedTireId,
      cartDetails: this.cartDetails,
      source: 'tirehub',
      callingFrom,
    });
  }

  setCartSummary(callingFrom?: string) {
    this.cartSummary = {
      total: 0,
      shippingCost: 0,
      grand: 0,
      count: 0,
      totalPrice: 0,
      grandPrice: 0,
      totalTaxAmount: 0,
      totalFetValue: 0,
    };
    this.cartitemList.forEach(({ tires, total }) => {
      this.cartSummary.total += this.calculationService.roundOff(total?.cost);
      this.cartSummary.shippingCost += this.calculationService.roundOff(total?.shippingCost);

      if (this.isOpenFromQuickTireLookup || this.isOpenFromRO) {
        this.cartSummary.totalPrice += this.calculationService.roundOff(total?.price);

        if (this.isQTQAddOnEnable) {
          this.cartSummary.totalTaxAmount += total?.totalTaxAmount || 0;
          if (this.isPassThroughTaxEnable) {
            this.cartSummary.totalFetValue += total?.totalFetValue || 0;
          }
        }
      }

      if (tires?.length) {
        tires.forEach(({ price, count }) => {
          this.cartSummary.count += count;
        });
      }
    });
    this.cartSummary.grand = this.calculationService.roundOff(this.cartSummary.total + this.cartSummary.shippingCost);
    if (this.isOpenFromQuickTireLookup || this.isOpenFromRO) {
      this.cartSummary.grandPrice = this.calculationService.roundOff(this.cartSummary.totalPrice + this.cartSummary.shippingCost);
    }
    if (this.isQTQAddOnEnable) {
      //this.cartSummary.grand += this.calculationService.roundOff(this.cartSummary.totalTaxAmount);
      this.cartSummary.grandPrice += this.calculationService.roundOff(this.cartSummary.totalTaxAmount);
      if (this.isPassThroughTaxEnable) {
        this.cartSummary.grand += this.calculationService.roundOff(this.cartSummary.totalFetValue);
        this.cartSummary.grandPrice += this.calculationService.roundOff(this.cartSummary.totalFetValue);
      }
      this.setGlobalCartAdSummary(callingFrom);
    }
  }

  handleTireSelect(tireId: string, tire: any, callingFrom?: string) {
    if (tire) {
      this.selectedTire[tireId] = tire;
    } else {
      if (this.selectedTire[tireId]?.warehouse?.warehouseId) {
        this.handleShipping(this.selectedTire[tireId]?.warehouse?.warehouseId, callingFrom);
      }

      delete this.selectedTire[tireId];
    }

    if (Object.keys(this.selectedTire).length) {
      this.isTireSelected = true;
    } else {
      this.isTireSelected = false;
    }

    if (tire) {
      const _tire = this.helperService.deepCopy(tire);

      this.cartDetails[tireId] = _tire;
    } else {
      delete this.cartDetails[tireId];
    }

    this.setCartDetails(false, callingFrom);
  }

  handleTaxSelect() {
    this.tires.forEach((tire: any) => {
      const taxCalculated = this.calculationService.calculateOrderItemTaxes({
        total: tire?.price || 0,
        taxRates: this.selectedTax?.taxRates,
        roundOffTax: false,
      });
      tire.tireSalesTaxAmt = taxCalculated?.taxAmt;
      tire.locations?.forEach(({ warehouseId }) => {
        const orderItemId: string = `${warehouseId}-${tire.numericItemId}`;
        if (this.cartDetails[orderItemId]) {
          this.cartDetails[orderItemId].tireSalesTaxAmt = tire.tireSalesTaxAmt;
        }
        if (this.selectedTire[orderItemId]) {
          this.selectedTire[orderItemId].tireSalesTaxAmt = tire.tireSalesTaxAmt;
        }
      });
    });
    if (Object.keys(this.cartDetails)?.length) {
      this.setCartDetails(false);
    }
  }

  handleCountChange(tireId: string, count: number = 0, isAddedToCart?: boolean, callingFrom?: string) {
    let isShippingRecalculationNeeded = this.selectedTire[tireId] && Number(this.selectedTire[tireId].count) !== Number(count);

    if (this.selectedTire[tireId]) {
      this.selectedTire[tireId].count = Number(count);
    }

    if (this.cartDetails[tireId]) {
      this.cartDetails[tireId].count = Number(count);
    }

    if (isShippingRecalculationNeeded) {
      this.handleShipping(this.selectedTire[tireId]?.warehouse?.warehouseId, callingFrom);
    }
    this.setCartDetails(isAddedToCart, callingFrom);
    //debounce(this.setCartDetails, 600);
  }

  handleServiceCreate(services: any[] = []) {
    this.services = [...services];
  }

  handleClose(isSuccess: boolean = false, data: any) {
    this.dynamicDialogRef.close({ isSuccess, data });
  }

  handleValidation() {
    let isValid = true;

    Object.keys(this.selectedTire).forEach((tireId) => {
      if (!(this.selectedTire[tireId] && this.selectedTire[tireId].service)) {
        isValid = false;
      }
    });

    return isValid;
  }

  handleSaveCart() {
    if (this.isSubmitting) return;
    this.isSubmitting = true;

    this.httpService
      .saveTireHubCart(this.orderId, Object.values(this.cartDetails))
      .then((res) => {
        this.handleClose(true, { isReloadNeeded: true });
        this.helperService.showToaster('error', 'The shipping charges provided on unordered items are estimated, once the order is placed the charges are rechecked and updated.');
      })
      .catch((err) => {
        this.helperService.showToaster('error', err);
      })
      .finally(() => {
        this.isSubmitting = false;
      });
  }

  handleViewDetails(tire: any, viewDetails: boolean) {
    tire.viewDetails = viewDetails;
  }

  handleOpenLocationDialog(tire: any) {
    //const ref = this.dialogService.open(TireLocationSelectDialogComponent, {
    const ref = this.dialogService.open(TireAddToCartDialogComponent, {
      closeOnEscape: false,
      width: '650px',
      styleClass: 'add-dialog tire-location-select-modal',
      showHeader: false,
      data: {
        tireDetails: {
          ...tire,
          locations: tire?.locations,
          warehouses: this.selectedTireId[tire?.numericItemId]?.locations,
        },
        // locations: tire?.locations,
        // warehouses: this.selectedTireId[tire?.numericItemId]?.locations,
        source: 'tirehub',
        selectedQty: this.selectedQty,
        isOpenFromQuickTireLookup: this.isOpenFromQuickTireLookup,
        isRunTireStorageFlow: this.isRunTireStorageFlow
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        if (data?.locations?.length) {
          data.locations.forEach(({ warehouseId, name, count, totalAvailable, shippingCost }) => {
            const _tire = this.helperService.deepCopy(tire);

            _tire.orderItemId = `${warehouseId}-${_tire.numericItemId}`;

            if (this.selectedTire[_tire.orderItemId]?.orderItemIdUnique) {
              _tire.orderItemIdUnique = this.selectedTire[_tire.orderItemId].orderItemIdUnique;
            } else {
              _tire.orderItemId = `${Date.now()}-${_tire.orderItemId}`;
            }

            _tire.count = count;
            _tire.shippingCost = shippingCost;
            _tire.countAvailable = totalAvailable;
            _tire.warehouse = { warehouseId, name };
            if (data?.category) {
              _tire.category = data.category;
            }
            if (data?.tireType) {
              _tire.tireType = data.tireType;
            }
            if (data?.tireconnectFetValue) {
              _tire.tireconnectFetValue = data?.tireconnectFetValue;
            }
            if (data?.tireconnectFetSource) {
              _tire.tireconnectFetSource = data?.tireconnectFetSource;
            }
            if (data?.fetValue) {
              _tire.fetValue = data?.fetValue;
            }
            if (data?.fetValueSource) {
              _tire.fetValueSource = data?.fetValueSource;
            }
    
            if (this.selectedPricingMatrix && ['regular', 'fleet', 'custom'].includes(this.selectedPricingMatrix.type) && this.dataService.isAttributeBasedPricingEnable) {
              _tire.price = this.calculationService.calculateMarkUpUsingPricing(_tire.cost, this.selectedPricingMatrix?.defaultMatrix);
            } else if (this.tireHubSettings?.tire?.partsTechCostCalMethod === 'pricing-matrix') {
              _tire.price = this.calculationService.calculateMarkUpUsingPricing(_tire.cost, this.tireHubSettings?.tire?.pricing);
            }
            this.handleTireSelect(_tire.orderItemId, _tire);
            this.handleShipping(warehouseId);
          });
        }

        if (data.aLInvTire && this.isQTQAddOnEnable) {
          this.dataService.sendData(this.dataService.typePassData('handleTireSelectQTQ', { tireId: data.aLInvTire?._id, tire: data.aLInvTire, source: 'autoleap' }));
        }
      }

      onClose.unsubscribe();
    });
  }

  setItemCount() {
    this.updateSelectedItemCount.emit({ source: 'tirehub', count: this.cartSummary.count });
  }

  async handleShipping(warehouseId: string, callingFrom?: string) {
    this.isShippingCalculating = true;
    this.shippingLoader[warehouseId] = true;
    const payload = {
      warehouseId: warehouseId,
      items: [],
    };

    Object.values(this.cartDetails).forEach((tire: any) => {
      if (tire?.warehouse?.warehouseId === warehouseId) {
        payload.items.push({ itemId: tire.partNumber, quantity: this.selectedTire[tire.orderItemId]?.count });
      }
    });

    if (callingFrom && this.isQTQAddOnEnable) {
      this.appOnCalculatingShipping.emit({ isShippingCalculating: this.isShippingCalculating, shippingLoader: this.shippingLoader });
    }

    try {
      const { rate } = await this.httpService.getFreightCharges(payload);
      this.warehouseShippings[warehouseId] = rate;
      this.cartitemList.forEach((cart: any) => {
        if (cart?.warehouseId === warehouseId) {
          cart.total.shippingCost = rate;
          cart.total.total = (cart.total.cost || 0) + (cart.total.shippingCost || 0);

          if (this.isOpenFromQuickTireLookup || this.isOpenFromRO) {
            cart.total.totalPrice = (cart.total.price || 0) + (cart.total.shippingCost || 0);
          }
        }
      });
      this.setCartSummary(callingFrom);
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.isShippingCalculating = false;
      this.shippingLoader[warehouseId] = false;
      if (callingFrom && this.isQTQAddOnEnable) {
        this.appOnCalculatingShipping.emit({ isShippingCalculating: this.isShippingCalculating, shippingLoader: this.shippingLoader });
      }
    }
  }

  onScroll = debounce((event: any) => {
    if (this.isTireFetching || this.inventoryType === 'inventoryByLeadTime') return;
    // console.log(this.inventoryType);
    const element = event.target;

    if (element.scrollHeight - element.scrollTop - element.clientHeight < 10) {
      // console.log('fetch more');
      this.getTireHubInventory();
    }
  }, 400);

  handleViewTireDetails(tire: any) {
    const ref = this.dialogService.open(TireDetailsComponent, {
      closeOnEscape: false,
      width: '1000px',
      styleClass: 'add-dialog tire-connect-detail-modal',
      showHeader: false,
      data: {
        tireDetails: tire,
        hideCost: this.hideCost,
        source: 'tirehub',
        isOpenFromQuickTireLookup: this.isOpenFromQuickTireLookup,
        isOpenFromRO: this.isOpenFromRO,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess && data) {
        this.handleOpenLocationDialog(data);
      }

      onClose.unsubscribe();
    });
  }

  handleAddCustomerAndVehicle() {
    this.appOnAddCustomerAndVehicle.emit({ cartDetails: Object.values(this.cartDetails), source: 'TireHub' });
  }

  removeCartItems() {
    this.tires = [];
    this.cartDetails = {};
    this.cartSummary = {
      total: 0,
      shippingCost: 0,
      grand: 0,
      count: 0,
      totalPrice: 0,
      grandPrice: 0,
      totalTaxAmount: 0,
      totalFetValue: 0,
    };
    this.shippingLoader = {};
    this.cartitemList = [];
    this.selectedTireId = {};
    this.warehouseShippings = {};
    this.isCartVisible = false;
    this.setItemCount();
  }
}
